import { Component, Input } from "@angular/core"
import { DocumentMedia } from "../../models/resource/media"
import { AddOnViewService } from "../../services/add-on-view.service"
import { Observable, Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"
import { CautionFlagsService } from "../../services/caution-flags.service"

@Component({
    selector: "app-document-preview",
    templateUrl: "./document-preview.component.html",
    styleUrls: ["./document-preview.component.scss"],
    standalone: false,
})
export class DocumentPreviewComponent {
    @Input() documentMedia: DocumentMedia
    isCautionFlagContainerDisplayed: boolean = false
    cautionFlagButtonName: string = "View Document"

    private destroyed$: Subject<void> = new Subject<void>()

    cautionFlagDisplayObservable: Observable<boolean> =
        this.cautionFlagsService.cautionFlagDisplayObservable.pipe(
            takeUntil(this.destroyed$),
            tap((nextState: boolean) => (this.isCautionFlagContainerDisplayed = nextState))
        )

    constructor(
        public addOnViewService: AddOnViewService,
        private cautionFlagsService: CautionFlagsService
    ) {}

    ngOnInit() {
        this.cautionFlagDisplayObservable.subscribe()
    }

    public expand(): void {
        window.open(
            this.documentMedia.canonicalURL,
            "_blank",
            "height=700,width=1265,scrollbars=yes,resizable=yes"
        )
    }
}
